/**
 * @file switch.component.tsx
 * @path packages/ui/src/switch.component.tsx
 * @description
 */

import { cn } from "@sirbastians/utils";
import * as React from "react";
import * as SwitchPrimitives from "@radix-ui/react-switch";

const Switch = React.forwardRef<
  React.ElementRef<typeof SwitchPrimitives.Root>,
  React.ComponentPropsWithoutRef<typeof SwitchPrimitives.Root>
>(({ className, ...props }, ref) => (
  <SwitchPrimitives.Root
    className={cn(
      // TRACK STYLE:
      // 1. neuro-well: Deep groove.
      // 2. border-input: Visible edge.
      // 3. rounded-full: Capsule shape.
      "peer inline-flex h-7 w-12 shrink-0 cursor-pointer items-center rounded-full border-2 border-transparent transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background disabled:cursor-not-allowed disabled:opacity-50",

      // UNCHECKED: Darker/Recessed well
      "neuro-well bg-muted",

      // CHECKED: The well fills with green (Accent)
      "data-[state=checked]:bg-accent data-[state=checked]:neuro-well",

      className,
    )}
    {...props}
    ref={ref}
  >
    <SwitchPrimitives.Thumb
      className={cn(
        // THUMB STYLE:
        // A physical bead sliding inside the groove.
        // Shadow-sm gives it lift.
        "pointer-events-none block h-5 w-5 rounded-full bg-background ring-0 transition-transform data-[state=checked]:translate-x-5 data-[state=unchecked]:translate-x-0.5",
      )}
    />
  </SwitchPrimitives.Root>
));
Switch.displayName = SwitchPrimitives.Root.displayName;

export { Switch };
